export const index = '/';

export const authFinalize = '/auth-finalize';
